import { NgClass } from "@angular/common";
import {
  Component,
  computed,
  inject,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { TranslatePipe } from "@ngx-translate/core";
import { ProductDocumentsViewModel } from "../../../features/product-documents/product-documents-view-model";
import { DocumentIdStorageService } from "../../services/document-id-storage.service";
import { DataDocumentRow } from "../data-document-row/data-document-row";

@Component({
  selector: "claas-data-document",
  imports: [DataDocumentRow, TranslatePipe, NgClass],
  templateUrl: "./data-document.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./data-document.scss",
})
export class DataDocument {
  @Input()
  tableData: ProductDocumentsViewModel[] = [];

  @Input() hasAnyNewDocuments = false;

  documentIDStorageService = inject(DocumentIdStorageService);
  isDocumentIDOn = toSignal(this.documentIDStorageService.documentID$);
  isDocumentIDOnForCurrentDocument = computed(() => this.isDocumentIDOn());
}
